<script>
	export let dataMapped;
	import {Notebook} from '@manaakiwhenua/frag-svelte';
    import {default as maoriFactsheet} from '../notebooks/@ridgenb/maori-factsheet';

	const cells = [
	    'subHeaderBar3',
        'tableDescription',
        'tableSibling',
        'tableMetaText',
        'photoTexturePlot', 'photoWaterPlot',
        'splineDescription'];

	$: overrides = new Map([['dataMapped', dataMapped]]);
</script>

<div class="soil-horizons">
    <Notebook notebook={maoriFactsheet} cells={cells} overrides={overrides}/>
</div>


<style>
    .soil-horizons :global(.frag-notebook) {
        display: grid;
        grid-template-areas:
                "subHeaderBar3 subHeaderBar3"
                "tableDescription tableDescription"
                "tableSibling tableSibling"
                "tableMetaText tableMetaText"
                "photoTexturePlot photoWaterPlot"
                "splineDescription splineDescription";
    }

    .soil-horizons :global([data-cell=subHeaderBar3]) {
        grid-area: subHeaderBar3;
    }

    .soil-horizons :global([data-cell=tableDescription]) {
        grid-area: tableDescription;
    }
    .soil-horizons :global([data-cell=tableSibling]) {
        grid-area: tableSibling;
    }

    .soil-horizons :global([data-cell=tableSibling] table) {
        min-width: 100%;
    }

    .soil-horizons :global([data-cell=tableMetaText]) {
        grid-area: tableMetaText;
    }

    .soil-horizons :global([data-cell=photoTexturePlot]) {
        grid-area: photoTexturePlot;
    }

    .soil-horizons :global([data-cell=photoWaterPlot]) {
        grid-area: photoWaterPlot;
    }

    .soil-horizons :global([data-cell=photoTexturePlot] > img),
    .soil-horizons :global([data-cell=photoWaterPlot] > img) {
        width: 100%;
    }

    .soil-horizons :global([data-cell=splineDescription]) {
        grid-area: splineDescription;
    }

    @media screen and (max-width: 767px) {
        :global([data-cell=tableSibling]) {
            width: 100%;
            margin-bottom: 15px;
            overflow-y: hidden;
            -ms-overflow-style: -ms-autohiding-scrollbar;
            border: 1px solid #ddd;
            overflow-x: auto;
            min-height: 0.01%;
        }

        :global([data-cell=tableSibling] table th, [data-cell=tableSibling] table td) {
            white-space: nowrap;
        }
    }

    :global([data-cell=tableSibling] table th:first-child, [data-cell=tableSibling] table td:first-child) {
        padding-left: 0.25em;
    }

    :global([data-cell=tableSibling] table th:not(:last-child), [data-cell=tableSibling] table td:not(:last-child)) {
        padding-right: 0.5em;
    }

    @media screen and (max-width: 600px) {
        .soil-horizons :global(.frag-notebook) {
            display: grid;
            grid-template-areas:
                "subHeaderBar3"
                "tableDescription"
                "tableSibling"
                "tableMetaText"
                "photoTexturePlot"
                "photoWaterPlot"
                "splineDescription";
        }
    }
</style>